import { getState } from './storage';

// Tracks the current play session so auto-advance can never become an endless
// loop. A 2-year-old cannot self-regulate a stop, so the session ends itself.
// Budget comes from the parent's existing settings.sessionMinutes — we do not
// introduce a second setting.

const K_START = 'pp_session_start';
const K_COUNT = 'pp_session_games';
const DEFAULT_MINUTES = 10;
const HARD_CAP_GAMES = 12; // safety net if games run unusually fast

function store() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function startSession() {
  const s = store();
  if (!s) return;
  if (!s.getItem(K_START)) {
    s.setItem(K_START, String(Date.now()));
    s.setItem(K_COUNT, '0');
  }
}

export function countSessionGame() {
  const s = store();
  if (!s) return 1;
  const n = Number(s.getItem(K_COUNT) || 0) + 1;
  s.setItem(K_COUNT, String(n));
  return n;
}

export function sessionGamesPlayed() {
  const s = store();
  return s ? Number(s.getItem(K_COUNT) || 0) : 0;
}

// True while the child still has session budget left to keep playing.
export function sessionHasBudget() {
  const s = store();
  if (!s) return false;
  const minutes = getState().settings?.sessionMinutes ?? DEFAULT_MINUTES;
  const start = Number(s.getItem(K_START) || Date.now());
  const elapsedMinutes = (Date.now() - start) / 60000;
  return elapsedMinutes < minutes && sessionGamesPlayed() < HARD_CAP_GAMES;
}

export function endSession() {
  const s = store();
  if (!s) return;
  s.removeItem(K_START);
  s.removeItem(K_COUNT);
  s.removeItem(K_UPSELL);
}

// The upgrade screen may interrupt play at most once per session. Seeing it
// twice in one sitting reads as nagging, not as an offer.
const K_UPSELL = 'pp_session_upsell_shown';

export function upsellShownThisSession() {
  const s = store();
  return s ? s.getItem(K_UPSELL) === '1' : false;
}

export function markUpsellShown() {
  const s = store();
  if (s) s.setItem(K_UPSELL, '1');
}
